import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// SIGNUP redesign tokens + display face (dormant on main — nothing reads them
// until NEW_EXPERIENCE screens do; @font-face only downloads when a name uses it).
import './styles/signup-tokens.css';
import '@fontsource/space-grotesk/400.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/700.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import forceRebuild from './force-rebuild.js';
import { ensureServiceWorker } from './services/pushNotificationService';
import { initShellUpdate } from './services/versionCheck';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Force Netlify to rebuild by calling the function
if (process.env.NODE_ENV === 'production') {
  console.log('Force rebuild result:', forceRebuild());

  // App-shell SW (app-shell-instant-open.md): register early + unconditionally
  // for ALL users so the shell paints instantly on next open, then precache the
  // current shell in the background. Production/branch-deploy only — SWs cause
  // stale-code pain on the localhost dev server.
  ensureServiceWorker().then(() => initShellUpdate());
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
